import React from 'react';
import { Star, ArrowRight, Check } from 'lucide-react';
export function HeroSection() {
  const CART_URL = 'https://pagos.avanzalab.online/checkouts/cn/hWN93DDL9U3kekOUwznOUDsA/es-ar?_r=AQABwkeeujeS07sT7Ib3di0hHptvQRbNe-xmvwPH9xudHaM&cart_link_id=bk0g09nZ&preview_theme_id=185849938234';
  return <section className="w-full bg-[#0a0a0a] pb-16 pt-10 md:pt-16" aria-label="Presentación del Mega Pack Pisos Epoxi" data-id="element-92">
      <div className="max-w-4xl mx-auto px-4 text-center flex flex-col items-center" data-id="element-93">
        {/* Main Headline */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6 uppercase tracking-tight" data-id="element-94">
          Cobrá tu primer trabajo de pisos epoxi en menos de 30 días
        </h1>

        {/* Subtitle */}
        <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto font-medium" data-id="element-95">
          Aprendé paso a paso cómo transformar pisos comunes en acabados epoxi
          profesionales, incluso si hoy no tenés experiencia.
        </p>

        {/* Before/After Image (Main Visual) */}
        <div className="relative w-full max-w-3xl mx-auto rounded-2xl overflow-hidden shadow-2xl border-2 border-amber-600/30 mb-10 bg-[#111]" data-id="element-96">
          <img src="https://cdn.magicpatterns.com/uploads/szKS4iwC4ahXEiSTpXdTMy/WhatsApp_Image_2026-03-03_at_6.11.53_PM.jpg" alt="Comparación antes y después de un piso con acabado epoxi profesional" loading="eager" decoding="sync" width={800} height={600} className="w-full h-auto object-cover" data-id="element-97" />

          {/* Overlay Labels */}
          <div className="absolute bottom-4 left-4 md:left-8 bg-black/80 text-white px-4 py-1.5 rounded-md font-bold text-sm md:text-base tracking-wider backdrop-blur-sm border border-white/10" data-id="element-98">
            ANTES
          </div>
          <div className="absolute bottom-4 right-4 md:right-8 bg-black/80 text-amber-400 px-4 py-1.5 rounded-md font-bold text-sm md:text-base tracking-wider backdrop-blur-sm border border-amber-500/30" data-id="element-99">
            DESPUÉS
          </div>
        </div>

        {/* 3 Bullets */}
        <ul className="inline-flex flex-col items-start text-left space-y-3 mb-10 list-none p-0" data-id="element-100">
          {['Qué materiales usar y cuánto invertir', 'Cómo aplicar epoxi correctamente sin arruinar el piso', 'Cómo cotizar y cobrar tu primer trabajo'].map((text, i) => <li key={i} className="flex items-center gap-3 text-lg md:text-xl text-gray-200 font-medium" data-id="element-101">
              <div className="bg-amber-500/20 p-1 rounded-full flex-shrink-0" data-id="element-102">
                <Check className="w-5 h-5 text-amber-500" aria-hidden="true" data-id="element-103" />
              </div>
              <span data-id="element-104">{text}</span>
            </li>)}
        </ul>

        {/* Social Proof */}
        <div className="inline-flex items-center justify-center gap-2 mb-8 bg-amber-900/20 py-3 px-6 rounded-full border border-amber-700/40" data-id="element-105">
          <div className="flex text-amber-500" aria-hidden="true" data-id="element-106">
            <Star className="w-5 h-5 fill-current" data-id="element-107" />
            <Star className="w-5 h-5 fill-current" data-id="element-108" />
            <Star className="w-5 h-5 fill-current" data-id="element-109" />
            <Star className="w-5 h-5 fill-current" data-id="element-110" />
            <Star className="w-5 h-5 fill-current" data-id="element-111" />
          </div>
          <span className="font-bold text-gray-200 text-sm md:text-base" data-id="element-112">
            +1.200 personas ya lo están aplicando
          </span>
        </div>

        {/* CTA Container */}
        <div className="w-full max-w-md mx-auto" data-id="element-113">
          <a href={CART_URL} className="w-full bg-amber-500 hover:bg-amber-400 text-black text-xl md:text-2xl font-black py-5 px-8 rounded-xl shadow-[0_4px_0_rgb(146,100,10)] hover:shadow-[0_2px_0_rgb(146,100,10)] hover:translate-y-[2px] transition-all flex items-center justify-center gap-3 mb-4" aria-label="Quiero empezar ahora - Acceder al Mega Pack" data-id="element-114">
            QUIERO EMPEZAR AHORA
            <ArrowRight className="w-6 h-6" aria-hidden="true" data-id="element-115" />
          </a>

          {/* Trust line */}
          <p className="text-sm text-gray-500 font-medium" data-id="element-116">
            Pago único • Acceso inmediato • Curso 100% online
          </p>
        </div>
      </div>
    </section>;
}